import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import classNames from "classnames";
import { bool, string, func, shape } from "prop-types";

import { actions as loginActions, selectors as loginSelectors } from "reducers/login";
import { selectors as sessionSelectors } from "reducers/session";

import Notification from "pages/_components/Notification";
import Step2Content from "pages/login/_components/Step2Content";
import Button from "pages/_components/Button";
import MainContainer from "pages/_components/MainContainer";
import withExchangeToken from "pages/_components/withExchangeToken";
import TooltipTour from "pages/forms/_components/_fields/TooltipTour";
import * as i18n from "util/i18n";
import { push } from "connected-react-router";
import Head from "pages/_components/Head";
import LogoTitle from "./_components/LogoTitle";

class LoginStep2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepsTour: [],
            runTooltipTour: false,
        };
    }

    componentDidMount() {
        const { dispatch, firstLog, activeEnvironment, username } = this.props;
        const { stepsTour } = this.state;
        if (activeEnvironment) {
            dispatch(push("/desktop"));
            return;
        }
        if (!username) {
            dispatch(push("/"));
            return;
        }
        if (!stepsTour.length) {
            const steps = stepsTour;
            steps.push({
                selector: "figureId",
                title: "tooltipTour.login.securityImage.title",
                content: i18n.get("tooltipTour.login.securityImage.content"),
            });
            this.setState({
                stepsTour: steps,
                runTooltipTour: firstLog,
            });
        }
    }

    componentWillUnmount() {
        this.setState({
            stepsTour: [],
            runTooltipTour: false,
        });
    }

    onHeaderClose = () => {
        const { dispatch } = this.props;
        dispatch(loginActions.reset());
        dispatch(push("/"));
    };

    onHeaderBack = () => {
        const { dispatch } = this.props;
        dispatch(push("/"));
    };

    render() {
        const { isDesktop, isInFlow, isTokenSuccess } = this.props;
        const { stepsTour, runTooltipTour } = this.state;
        return (
            <>
                <TooltipTour
                    steps={stepsTour}
                    run={runTooltipTour}
                    showNavigation={false}
                    showCloseButton={false}
                    showNumber={false}
                    closeWithMask={false}
                    lastStepNextButton={
                        <Button className="btn btn-outline btn-small">
                            {i18n.get("tooltipTour.lastButton.label")}
                        </Button>
                    }
                />
                <Notification scopeToShow="loginStep2" />
                {isInFlow && (
                    <>
                        <Head
                            title="login.step2.title"
                            styleOther={{ backgroundColor: "transparent", boxShadow: "none" }}
                            onBack={this.onHeaderBack}
                            hideNavbarInMobile
                        />

                        {!isDesktop && <LogoTitle />}
                        <MainContainer
                            className={classNames({ "container-fluid": isDesktop })}
                            showLoader={isTokenSuccess}>
                            <Step2Content />
                        </MainContainer>
                    </>
                )}
            </>
        );
    }
}

LoginStep2.propTypes = {
    isDesktop: bool.isRequired,
    isInFlow: bool.isRequired,
    dispatch: func.isRequired,
    firstLog: bool.isRequired,
    username: string.isRequired,
    activeEnvironment: shape({}).isRequired,
    isTokenSuccess: bool.isRequired,
};

const mapStateToProps = (state) => ({
    isInFlow: loginSelectors.getIsInFlow(state),
    fromOnboardingLoginData: loginSelectors.getFromOnboardingLoginData(state),
    firstLog: !loginSelectors.getHasLogged(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    username: loginSelectors.getUsername(state),
    hasLogged: loginSelectors.getHasLogged(state),
    isTokenSuccess: loginSelectors.getIsTokenSuccess(state),
});

export default compose(withRouter, connect(mapStateToProps))(withExchangeToken(LoginStep2));
